import React from 'react';
import { Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import ColorPalette from '../../../../colorpalette/ColorPalette';

/**
 * "Assistida" / "Marcar como assistida": mostra o estado da lição e deixa marcar ou desmarcar.
 * @param {Boolean} completed
 * @param {Function} onToggle - recebe o novo estado (true = assistida)
 */
const LessonWatchedToggle = ({ completed, onToggle }) => (
  <Button
    size="small"
    onClick={() => onToggle(!completed)}
    startIcon={completed ? <CheckCircleIcon /> : <RadioButtonUncheckedIcon />}
    title={completed ? 'Desmarcar como assistida' : undefined}
    sx={{
      textTransform: 'none',
      fontWeight: 600,
      fontSize: '0.8rem',
      borderRadius: '999px',
      px: 1.5,
      color: completed ? '#2E7D32' : ColorPalette.textMedium,
      backgroundColor: completed ? ColorPalette.successLight : 'transparent',
      '&:hover': { backgroundColor: completed ? '#DCEFDD' : ColorPalette.bgMain }
    }}
  >
    {completed ? 'Assistida' : 'Marcar como assistida'}
  </Button>
);

export default LessonWatchedToggle;
